module.exports = __webpack_public_path__ + "2d92b35e3a96693ee2e14fb3803de5f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-29.jpg
// module id = 1170
// module chunks = 0